<template>
  <div v-if="option">
    <div class="payment-wizard-option">
      <h3 class="payment-wizard-option__title">{{ option.name }}</h3>
      <div class="payment-wizard-option__amount">
        <span>Charge amount ($)</span>
        <span>{{ option.charge_amount }}</span>
      </div>

      <!-- Fee line items — calculated against this option's own charge_amount -->
      <template v-if="applicableFees.length">
        <div
          v-for="fee in applicableFees"
          :key="'wizard_fee_' + fee.id"
          class="payment-wizard-option__fee"
        >
          <span>
            {{ fee.name }}
            <span class="payment-wizard-option__fee-hint">
              ({{ fee.type === 'percentage' ? fee.value + '%' : '$' + fee.value }})
            </span>
          </span>
          <span>+${{ fee.calculatedAmount.toFixed(2) }}</span>
        </div>
        <div class="payment-wizard-option__total">
          <span>Total</span>
          <span>${{ (chargeAmount + totalFeeAmount).toFixed(2) }}</span>
        </div>
      </template>

      <div class="payment-wizard-option__description">
        <span>{{ option.description }}</span>
      </div>
    </div>

    <PaymentPlan
       v-if="option.payment_plan_is_enable"
       :option="option"
       :isDisabledField="isDisabledField"
       :total-fee-amount="totalFeeAmount"
    />
  </div>
</template>

<script>
import PaymentPlan from '@/components/site/PaymentPlan.vue'
import { calculateApplicableFees } from '@/utils/payment'

export default {
  components: {
    PaymentPlan,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    isDisabledField: {
      type: Boolean,
      default: false,
    },
    // Raw fee configs from the program — amounts are computed locally
    paymentFees: {
      type: Array,
      default: () => [],
    },
    // The active payment method string ('Credit Card', 'ACH', etc.)
    paymentMethod: {
      type: String,
      default: null,
    },
  },
  computed: {
    chargeAmount() {
      return Number(this.option?.charge_amount) || 0
    },
    /**
     * Fees applicable to this option's own charge amount.
     * Recalculates whenever chargeAmount or paymentMethod changes.
     */
    applicableFees() {
      if (!this.paymentMethod || !this.chargeAmount) return []
      return calculateApplicableFees(this.paymentFees, this.paymentMethod, this.chargeAmount, 'PaymentWizardField')
    },
    totalFeeAmount() {
      return this.applicableFees.reduce((sum, f) => sum + f.calculatedAmount, 0)
    },
  },
}
</script>

<style scoped>
.payment-wizard-option__fee {
  display: flex;
  justify-content: space-between;
  font-size: 0.88em;
  color: #666;
  margin-top: 4px;
}

.payment-wizard-option__fee-hint {
  font-size: 0.82em;
  color: #999;
  margin-left: 3px;
}

.payment-wizard-option__total {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-top: 6px;
  padding-top: 4px;
  border-top: 1px solid #e0e0e0;
}
</style>
